module.exports = __webpack_public_path__ + "img/card-loyal2.07c48f6b.svg";